import React, { useEffect, useState } from "react";
import { BsArrowLeft } from "react-icons/bs";
import { CiEdit } from "react-icons/ci";
import { GoTrash } from "react-icons/go";
import notFount from "../../../../src/assets/img/image-not-found.png";
import "./Inventory.scss";
import { Box, Modal } from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../../context/AuthProvider";
import { HttpService } from "../../../service/HttpService";
import { useFilter } from "../../../context/FilterProvider";
import { toast } from "react-toastify";
import FullScreenLoader from "../../../components/Loader/FullScreenLoader";
import { Decryption } from "../../../Mixin/EncryptDecryptId";
import AddEditInventory from "../../../components/Inventory/AddEditInventory";
import DeleteModal from "../../../components/Model/DeleteModal";
import HistoryModal from "../HistoryModal/HistoryModal";

const InventoryView = () => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    boxShadow: 24,
  };
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = React.useState(false);
  const [openHistory, setOpenHistory] = React.useState(false);
  const { setShowLoginPopup, showLoginPopup } = useAuth();
  const httpService = new HttpService(setShowLoginPopup);
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [inventory, setInventory] = useState([]);
  const [deleteImg, setDeleteImg] = useState("");
  const [Deleteinventory, SetDeleteInventory] = useState(false);
  const decryptedId = params?.id && Decryption(params?.id);
  const { company_id, location_id } = useFilter();
  const [historyData, setHistoryData] = useState([]);
  const handleOpen = () => {
    setOpen(true);
    // fetchInventory();
  };
  const handleClose = () => {
    setOpen(false);
    setOpenHistory(false);
    setDeleteImg("");
    SetDeleteInventory(false);
    // fetchInventory();
  };

  const handleOpenHistory = () => {
    setOpenHistory(true);
    // fetchUsedQuantity();
  };

  const fetchInventory = async () => {
    setLoading(true);
    await httpService
      .get(`inventory/${decryptedId}`)
      .then((response) => {
        setInventory(response?.data);
        setDeleteImg("");
        setTimeout(() => {
          setLoading(false);
        }, 300);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching data:", error);
      });
  };

  const fetchHistory = () => {
    setLoading(true);
    httpService
      .get(`inventory/transactions/${decryptedId}`)
      .then((response) => {
        setHistoryData(response?.data?.history);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    fetchInventory();
    fetchHistory();
  }, [params?.id, showLoginPopup]);

  const HandleDeleteInventory = async () => {
    if (deleteImg !== "" && deleteImg !== undefined) {
      await handleDeleteImg(deleteImg);
    } else {
      try {
        let response = await httpService.delete(
          `${"inventory/delete_inventory"}/${decryptedId}`
        );
        navigate("/inventory");
        if (response) {
          toast.success("Inventory Deleted successfully", {
            position: "top-right",
          });
          SetDeleteInventory(false);
          // fetchInventory();
        }
      } catch (error) {
        SetDeleteInventory(false);
      }
    }
  };

  const handleDeleteImg = async (imgId) => {
    const newArray = [...inventory?.attached]; // Create a copy of the attached array
    newArray.splice(imgId, 1);

    const formData = new FormData();
    for (const key in inventory) {
      if (key === "attached") {
        for (let i = 0; i < newArray.length; i++) {
          formData.append(`existFile[${i}]`, newArray[i]);
        }
      }
      // else {
      //   if (inventory[key] !== null) {
      //     const value =
      //       key === "sort_order" ? inventory[key] || "" : inventory[key];
      //     formData.append(key, value);
      //   }
      // }
    }
    try {
      let response = await httpService.put(
        `${"inventory/edit_inventory"}/${decryptedId}`,
        formData
      );
      if (response.message) {
        SetDeleteInventory(false);
        // fetchInventory();
        toast.success("File Deleted successfully", {
          position: "top-right",
        });
      }
    } catch (error) {
      SetDeleteInventory(false);
    }
  };

  const backToHome = () => {
    if (location?.state?.from === "reorderInventory") {
      navigate(`/${location.state.from}`);
    } else {
      navigate("/inventory");
    }
  };

  return (
    <>
      {loading && <FullScreenLoader />}
      <div className="inventory-view">
        <div className="page-title">
          <div className="title-wrap">
            <h1>
              <span className="back">
                <BsArrowLeft onClick={() => backToHome()} />
              </span>
              Inventory Details - [
              {inventory?.item_name ? inventory?.item_name : ""}]
            </h1>
          </div>
          <div className="button-wrap view-responsive">
            <button
              type="submit"
              className="btn btn-edit"
              onClick={() => handleOpen()}
            >
              <CiEdit /> Edit{" "}
            </button>
            <button
              type="submit"
              className="btn btn-delete"
              onClick={() => {
                SetDeleteInventory(true);
              }}
            >
              <GoTrash /> Delete{" "}
            </button>
          </div>
        </div>
        <div>
          <div className="row">
            <div className="col-md-2 mb-4 mb-md-0">
              <div>
                <img
                  src={
                    inventory?.image_file_path
                      ? inventory?.image_file_path
                      : notFount
                  }
                  className="img-fluid"
                  alt="Inventory img"
                />
              </div>
            </div>
            <div className="col-md-10">
              <div className="row">
                <div className="col-md-2">
                  <div className="d-flex justify-content-md-between">
                    <label>Name </label>
                    <span>:</span>
                  </div>
                </div>
                <div className="col-md-10">
                  <p>{inventory?.item_name ? inventory?.item_name : "--"}</p>
                </div>
                <div className="col-md-2">
                  <div className="d-flex justify-content-md-between">
                    <label>Department </label>
                    <span>:</span>
                  </div>
                </div>
                <div className="col-md-10">
                  <p>
                    {inventory?.department_name
                      ? inventory?.department_name
                      : "--"}
                  </p>
                </div>
                {/* Item Description */}
                <div className="col-md-2">
                  <div className="d-flex justify-content-md-between">
                    <label>Item Description</label>
                    <span>:</span>
                  </div>
                </div>
                <div className="col-md-10">
                  <p>
                    {inventory?.item_description
                      ? inventory?.item_description
                      : "--"}
                  </p>
                </div>
                {/* Supplier */}
                <div className="col-md-2">
                  <div className="d-flex justify-content-md-between">
                    <label>Supplier Name</label>
                    <span>:</span>
                  </div>
                </div>
                <div className="col-md-10">
                  <p>{inventory?.supplier ? inventory?.supplier : "--"}</p>
                </div>
                <div className="col-md-2">
                  <div className="d-flex justify-content-md-between">
                    <label>Store Location </label>
                    <span>:</span>
                  </div>
                </div>
                <div className="col-md-10">
                  <p>
                    {inventory?.stored_location
                      ? inventory?.stored_location
                      : "--"}
                  </p>
                </div>
                <div className="col-md-2">
                  <div className="d-flex justify-content-md-between">
                    <label>Unit Price </label>
                    <span>:</span>
                  </div>
                </div>
                <div className="col-md-10">
                  <p>
                    {parseFloat(inventory?.feed_rate_per_week)
                      ? parseFloat(inventory?.feed_rate_per_week)
                      : "--"}
                  </p>
                </div>
                <div className="col-md-2">
                  <div className="d-flex justify-content-md-between">
                    <label>History </label>
                    <span>:</span>
                  </div>
                </div>
                <div className="col-md-10">
                  <span
                    onClick={() => handleOpenHistory()}
                    className={`show-history ${
                      historyData?.length === 0 ? "disabled-div" : ""
                    }`}
                  >
                    View History
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {open && (
        <AddEditInventory
          open={open}
          handleClose={() => handleClose()}
          inventory_id={decryptedId}
          isAdd={false}
          // fetchInventory={() => fetchInventory()}
          companyId={company_id}
          locationId={location_id}
        />
      )}

      <DeleteModal
        open={Deleteinventory}
        HandleClose={() => handleClose()}
        id={deleteImg}
        HandleDelete={() => HandleDeleteInventory()}
      />

      {openHistory && (
        <HistoryModal
          open={openHistory}
          handleClose={() => handleClose()}
          id={decryptedId}
        />
      )}
    </>
  );
};

export default InventoryView;
